export enum addressType{
    POSTAL="POSTAL",
    GEOLOC = "GEOLOC",
    GEOGRAPHICAL = "GEOGRAPHICAL",
    EMAIL = "EMAIL",
    TELEPHONE = "TELEPHONE",
    WEB = "WEB",
    ELECTRONIC = "ELECTRONIC",
    INTERNALLOCATION = "INTERNALLOCATION"
}
export enum type {
    GROUP="GROUP",
    COMPANY = "COMPANY",
    SITE = "SITE"
}
export enum personRoleStatus {
    DRAFT="DRAFT",
    PENDING_VALIDATION = "PENDING_VALIDATION",
    VALIDATED = "VALIDATED",
    ARCHIVED = "ARCHIVED"

}
export enum  status{
    DRAFT ="DRAFT",
    PENDING_VALIDATION = "PENDING_VALIDATION",
    VALIDATED = "VALIDATED",
    ARCHIVED = "ARCHIVED"
}
export enum phoneType {
    F="F",
    P="P"
}
export enum loginType {
    RENAULT_IPN="RENAULT_IPN",
    AZURE_ID="AZURE_ID"
}
export class emailAddresses{
    "addressSummary": string
      "addressType": addressType
      "addressIdentifier": string
      "email": string
      "rowId": string
}
export class emailAddressesArray{
    "emailAddresses": emailAddresses[]
}
export class personAddresses{
    "summary": string 
      "addressType": addressType
      "personRowId": string
      "personIdentifier": string
      "personLastName": string
      "addressIdentifier": string
      "personFirstName": string
      "rowId": string
      "addressId": string
}
export class personAddressesArray{
    "personAddresses": personAddresses[]
}
export class personRoles{
    "roleTypeId": string
    "comments": string
    "roleTypeLabel": string
    "endDate": string
    "personRowId": string
    "type": type
    "rowId": string
    "personIdentifier": string
    "personLastName": string
    "personRoleStatus": personRoleStatus
    "personFirstName": string
    "startDate": string
    "roleTypeCode": string
}
export class personRolesArray
{
    "personRoles": personRoles[]
}
export class PersonRoleTypes{
    "roleTypeLabel": string
      "categoryCode": string
      "roleTypeDescription": string
      "roleTypeCode": string
      "categoryId": string
      "rowId": string}
export class personRoleTypesArray{
    "personRoleTypes": PersonRoleTypes[]
}export class persons{
    "comments": string
      "personIdentifier": string
      "personLastName": string
      "personFirstName": string
      "rowId": string     
}
export class personsArray{
   "persons": persons[]
}
export class siteRoles{
    "roleTypeId": string
      "comments": string
      "roleTypeLabel": string
      "siteIdentifier": string
      "endDate": string
      "personRowId":string
      "type": type
      "rowId": string
      "personSupplierCompany": any
      "supplierCompanyIdentifier": string
      "site": any
      "personIdentifier": string
      "personLastName": string
      "personRoleStatus": personRoleStatus
      "personFirstName": string
      "startDate": string
      "roleTypeCode": string
}

export class siteRolesArray{
    "supplierSiteRoles": siteRoles[]
}
export class supplierCompanyRoles{
"roleTypeId": string
"comments":string
"roleTypeLabel": string
"endDate": string
"personRowId": string
"type": type
"rowId": string
"personSupplierCompany":any
"supplierCompanyIdentifier": string
"personIdentifier": string
"personLastName": string
"personRoleStatus": personRoleStatus
"personFirstName": string
"startDate": string
"roleTypeCode": string
}
 export class supplierCompanyRolesArray{
    "supplierCompanyRoles" : supplierCompanyRoles[]
 }
 export class supplierGroupRoles {
      "supplierGroup": any
      "roleTypeId": string
      "comments":string
      "roleTypeLabel": string
      "endDate":string
      "personRowId": string
      "supplierGroupIdentifier": string
      "type": type
      "rowId": string
      "personIdentifier": string
      "personLastName": string
      "personRoleStatus": personRoleStatus
      "personFirstName": string
      "startDate": string
      "roleTypeCode": string
}
export class supplierGroupRolesArray{
    "supplierGroupRoles" : supplierGroupRoles[]
}
export class telephoneAddresses{

    "addressSummary": string
      "phoneType": phoneType
      "phoneNumber": string
      "addressType": addressType
      "addressIdentifier": string
      "rowId": string
}
export class telephoneAddressesArray{
    "telephoneAddresses": telephoneAddresses[]
}
export class users{
  "loginId": string
  "endDate": string
  "loginType": loginType
  "personRowId": string
  "personIdentifier": string
  "startDate": string
  "rowId": string
}
export class usersArray{
   "users": users[]
}

